<section #panel class="quick-forecast" data-test="quick-forecast" (keydown)="onKeyDown($event)">

    <header class="quick-forecast__header">
        <h3 class="quick-forecast__title">QuickForecast</h3>
        <button [matMenuTriggerFor]="infoMenu"
                aria-label="About QuickForecast"
                data-test="quick-forecast-info"
                mat-icon-button>
            <mat-icon>info_outline</mat-icon>
        </button>
        <button (click)="onCloseClicked()"
                aria-label="Close QuickForecast"
                data-test="quick-forecast-close"
                mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <mat-menu #infoMenu="matMenu" xPosition="before" class="quick-forecast__info-menu">
        <div class="quick-forecast__info" (click)="$event.stopPropagation()" data-test="quick-forecast-info-panel">
            <section class="quick-forecast__info-section">
                <p>Input first year forecast rates, and then grow them over time at a constant rate. Constant rates can be applied through:</p>
                <ul>
                    <li><strong>Addition</strong>: Absolute values (% or 'x') that grow by: [Prior Year Value] + [entered value] each year.</li>
                    <li><strong>Compound</strong>: Grows by the same growth rate each year: i.e. if [forecast growth] = 10%, then a 5% revenue growth rate will be 5.5% the next year, and 6.05% the following year.</li>
                </ul>
            </section>
        </div>
    </mat-menu>

    <div class="quick-forecast__column-headers">
        <span></span>
        <span class="quick-forecast__column-label">1st year</span>
        <span class="quick-forecast__column-label">YoY Incr</span>
    </div>

    <form [formGroup]="form" class="quick-forecast__rows">
        @for (metric of metrics; track metric.key) {
            <div class="quick-forecast__row" [formGroupName]="metric.key" data-test="quick-forecast-row">
                <label class="quick-forecast__row-label" [for]="metric.key + '_firstYear'">
                    {{ metric.label(earningBase) }}
                </label>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="quick-forecast__field">
                    <input #metricInput
                           [id]="metric.key + '_firstYear'"
                           [attr.data-test]="'quick-forecast-' + metric.key + '-firstYear'"
                           formControlName="firstYear"
                           inputmode="decimal"
                           matInput
                           type="number">
                    <span matTextSuffix>{{ metric.firstYearSuffix }}</span>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="quick-forecast__field">
                    <input #metricInput
                           [id]="metric.key + '_yoy'"
                           [attr.data-test]="'quick-forecast-' + metric.key + '-yoy'"
                           formControlName="yoy"
                           inputmode="decimal"
                           matInput
                           type="number">
                    <span matTextSuffix>{{ metric.yoySuffix(mode()) }}</span>
                </mat-form-field>
            </div>
        }
    </form>

    <footer class="quick-forecast__footer">
        <mat-button-toggle-group [value]="mode()"
                                 (change)="onModeChange($event.value)"
                                 data-test="quick-forecast-mode-toggle">
            <mat-button-toggle value="ADDITIVE"
                               matTooltip="YoY is added: 10% + 5% → 15%">
                Addition
            </mat-button-toggle>
            <mat-button-toggle value="COMPOUND"
                               matTooltip="YoY is compounded: 10% × 1.05 → 10.5%">
                Compound
            </mat-button-toggle>
        </mat-button-toggle-group>
    </footer>
</section>
